











































import Vue from "vue";
import Scanner from "@/common/components/scanner/Scanner.vue";
import { Result } from "@zxing/library";

export default Vue.extend({
  name: "PPBarcodeScanner",
  components: { Scanner },
  data() {
    return {
      scanning: false as boolean,
      scannedText: null as null | string,
    };
  },
  methods: {
    onScanned(result: Result): void {
      this.scannedText = result.getText();
    },
    emitBarcode(): void {
      if (this.scannedText) {
        this.$emit("barcode", this.scannedText);
      }
    },
    openScanner(): void {
      this.scanning = true;
    },
    closeScanner(): void {
      this.scanning = false;
    },
  },
});
